import { render, staticRenderFns } from "./DataListRiskProfile.vue?vue&type=template&id=e5aacdde&scoped=true&"
import script from "./DataListRiskProfile.vue?vue&type=script&lang=js&"
export * from "./DataListRiskProfile.vue?vue&type=script&lang=js&"
import style0 from "./DataListRiskProfile.vue?vue&type=style&index=0&id=e5aacdde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aacdde",
  null
  
)

export default component.exports